<template>
  <div>
    <v-container fluid>
      <v-row class="px-md-5 px-2 py-5">
        <v-col cols="12">
          <TableInfo :title="title" :tableInfo="rahbariyat" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import TableInfo from '@/components/tableInfo.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: "Rahbariyat",
  components: { TableInfo },
  data() {
    return {
      title: "Rahbariyat",
    }
  },
  created() {
    this.getPerson();
  },
  computed: {
    ...mapGetters("personal", ["person"]),
    rahbariyat() {
      return this.person.filter((x) => { return x.send_who == 'Rahbariyat' })
    },
  },
  methods: {
    ...mapActions("personal", ["getPerson"])
  }
}
</script>

<style lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
</style>